export const PLANNING_BOARD_DEFAULT_PAGE_SIZE = 10;
